import type { ChargeName } from '../models/charge.ts'
import { capitalizeFirstLetter } from './string-helpers.ts'

export const taxChargeNames: ChargeName[] = ['gst', 'hst', 'pst', 'qst', 'iva']

export const isTaxCharge = (name: ChargeName) => taxChargeNames.includes(name)

export const chargeNameLabel = (name: ChargeName): string => {
  if (isTaxCharge(name)) return name.toUpperCase()
  return capitalizeFirstLetter(name)
}
